import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import getContrastColor from 'app/utils/text-color-helper';
import { ModalDialogData } from '../modal-color-picker/modal-color-picker.component';

@Component({
  selector: 'app-modal-button-style',
  templateUrl: './modal-button-style.component.html',
  styleUrl: './modal-button-style.component.scss',
  standalone: false,
})
export class ModalButtonStyleComponent {
  protected color = '#091d50';

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalDialogData,
    private dialogRef: MatDialogRef<ModalButtonStyleComponent>,
  ) {
    this.color = data.color;
  }

  protected getTextColor(color: string) {
    return getContrastColor(color);
  }

  public closeModal() {
    this.dialogRef.close();
  }

  public pickColor() {
    this.dialogRef.close(this.color);
  }
}
